import React from 'react';

// This is an image of a box with an upward upload arrow that should be called UploadIcon
export default {
  svg: (
    <g>
      <path
        d="M246.57129,269.58319H53.42871A13.44384,13.44384,0,0,1,40,256.15448V102.90932a13.44383,13.44383,0,0,1,13.42871-13.4287h65.58245v16.11445H56.11445V253.46874h187.7711V105.59507H179.17177V89.48062h67.39952A13.44383,13.44383,0,0,1,260,102.90932V256.15448A13.44384,13.44384,0,0,1,246.57129,269.58319ZM158.05722,67.47156H141.94278V199.90327h16.11444ZM177.319,57.73563,150,30.41681,122.681,57.73563V80.93238L150,53.59744l27.319,27.33494Z"
        fillRule="evenodd"
      />
    </g>
  ),
  viewBox: '0 0 300 300'
};
